import { render, staticRenderFns } from "./ImageIconWoocommerce.vue?vue&type=template&id=5f2f259e"
import script from "./ImageIconWoocommerce.vue?vue&type=script&lang=js"
export * from "./ImageIconWoocommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports